import React from 'react';

/**
 * Ritaglio statico della lista prodotti del Magazzino, con lo stesso
 * vocabolario visivo di ProductList.tsx (intestazione #FBFBFA, th 11px
 * maiuscoletto, pill di stato scorta). È una `<table>` e non una pila di
 * `<div>` di proposito: la regola globale in index.css
 * (`div[class*="bg-white"] > div[class*="border-b"]`) forza a bianco pieno
 * qualunque div-riga e renderebbe illeggibile l'anteprima.
 */
const DEMO_PRODUCTS = [
  { sku: 'PRD-001', name: 'Pannello LED 60W', qty: 142, alert: 'in_stock' },
  { sku: 'PRD-002', name: 'Cavo RJ45 Cat6 (100 m)', qty: 8, alert: 'low_stock' },
  { sku: 'PRD-003', name: 'Switch 24p Gigabit', qty: 34, alert: 'in_stock' },
  { sku: 'PRD-004', name: 'UPS 1500VA', qty: 0, alert: 'out_of_stock' },
];

const STOCK_BADGE: Record<string, { label: string; className: string }> = {
  in_stock: {
    label: 'Disponibile',
    className: 'bg-green-100 dark:bg-green-900/50 text-green-800 dark:text-green-200',
  },
  low_stock: {
    label: 'Scorte basse',
    className: 'bg-yellow-100 dark:bg-yellow-900/50 text-yellow-800 dark:text-yellow-200',
  },
  out_of_stock: {
    label: 'Esaurito',
    className: 'bg-red-100 dark:bg-red-900/50 text-red-800 dark:text-red-200',
  },
};

export const WarehousePreview: React.FC = () => (
  <div
    aria-hidden="true"
    className="rounded-lg border border-[rgba(55,53,47,0.09)] dark:border-gray-700 overflow-hidden select-none"
  >
    <table className="w-full border-collapse">
      <thead className="bg-[#FBFBFA] dark:bg-gray-900/40">
        <tr className="border-b border-[rgba(55,53,47,0.09)] dark:border-gray-700">
          <th className="px-3 py-2 text-left text-[10px] font-medium text-[#787774] dark:text-gray-400 uppercase tracking-wider">
            SKU
          </th>
          <th className="px-3 py-2 text-left text-[10px] font-medium text-[#787774] dark:text-gray-400 uppercase tracking-wider">
            Prodotto
          </th>
          <th className="px-3 py-2 text-right text-[10px] font-medium text-[#787774] dark:text-gray-400 uppercase tracking-wider">
            Qtà
          </th>
          <th className="px-3 py-2 text-right text-[10px] font-medium text-[#787774] dark:text-gray-400 uppercase tracking-wider">
            Stato
          </th>
        </tr>
      </thead>
      <tbody>
        {DEMO_PRODUCTS.map((p) => {
          const badge = STOCK_BADGE[p.alert];
          return (
            <tr
              key={p.sku}
              className="border-b border-[rgba(55,53,47,0.06)] dark:border-gray-700/60 last:border-b-0"
            >
              <td className="px-3 py-2 text-[11px] font-mono text-[#787774] dark:text-gray-400">
                {p.sku}
              </td>
              <td className="px-3 py-2 text-[12px] text-[#37352F] dark:text-gray-200 truncate">
                {p.name}
              </td>
              <td className="px-3 py-2 text-[12px] text-right font-medium text-[#37352F] dark:text-gray-200">
                {p.qty}
              </td>
              <td className="px-3 py-2 text-right">
                <span
                  className={`inline-flex px-1.5 py-0.5 text-[10px] font-semibold rounded-full ${badge.className}`}
                >
                  {badge.label}
                </span>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);
